
import {toggleDisplay} from './Util';

class ImageErrorHandler {

	constructor( imageEl ) {
		imageEl.addEventListener( 'error', ( evt ) => toggleDisplay( evt.target, false ) );
	}
}

const initImageErrorHandler = ( scopeEl = document ) => {
	scopeEl.querySelectorAll( 'img.en_js_hide_onerror' ).forEach( imageEl => {
		imageEl.SL_ErrorHandler ??= new ImageErrorHandler( imageEl );
	} );
}

export {
	ImageErrorHandler as default,
	initImageErrorHandler
}
